export default __webpack_public_path__ + "static/media/epistreet.e4e7a73d.png";